import { prettyName } from '../../../lib/mandal-name'

import type { SurveyReportRow, SurveyReportStatus } from '../../../api/types'

/** The Survey-status table body — the gated content of the Coverage `SurveyStatusCard`. */
export function SurveyStatusTable({ rows, status }: { rows: SurveyReportRow[]; status: SurveyReportStatus }) {
  return (
    <table className="w-full text-[12px]" aria-label="Surveys by status">
      <thead>
        <tr className="text-muted-text text-left">
          <th className="py-1 pr-2 font-semibold">Officer</th>
          <th className="py-1 pr-2 font-semibold">Mandal</th>
          <th className="py-1 pr-2 font-semibold">Survey</th>
          <th className="py-1 font-semibold">{status === 'missed' ? 'Missed' : 'Scheduled'}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={`${r.id}-${i}`} className="border-t border-slate-900/5">
            <td className="py-1.5 pr-2">{r.foName ?? '—'}</td>
            <td className="py-1.5 pr-2">{prettyName(r.mandal)}</td>
            <td className="py-1.5 pr-2">{r.surveyName}</td>
            <td className="py-1.5 tabular-nums">{r.scheduledDate ?? '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
